import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

// WICHTIG: Das CSS von Swiper importieren!
// Damit das funktioniert, muss dein Build-System CSS-Imports unterstützen (Standard in wp-scripts)
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll<HTMLElement>(".product-slider-wrapper");

  sliders.forEach((sliderRoot) => {
    const topRow = sliderRoot.querySelector(".swiper-row-top") as HTMLElement;
    const bottomRow = sliderRoot.querySelector(".swiper-row-bottom") as HTMLElement;

    const nextBtn = sliderRoot.querySelector(".swiper-custom-next") as HTMLElement;
    const prevBtn = sliderRoot.querySelector(".swiper-custom-prev") as HTMLElement;

    // Basis Konfiguration
    const baseConfig = {
      modules: [Autoplay, Navigation],
      slidesPerView: 1.3,
      loop: true,

      spaceBetween: 32,
      centeredSlides: false,
      breakpoints: {
        768: { slidesPerView: 2.6 },
        1024: { slidesPerView: 3 },
        1900: { slidesPerView: 5 },
      },
    };

    // Konfiguration für den Marquee-Modus (durchgehender Fluss)
    const marqueeConfig = {
      speed: 6000, // Sehr langsam für flüssige Bewegung
      autoplay: {
        delay: 0, // Keine Wartezeit zwischen Slides
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      allowTouchMove: true, // User kann trotzdem grabben
    };

    // Konfiguration für den Single-Slider Modus (Standard-Verhalten)
    const singleConfig = {
      speed: 600, // Normale Slide-Geschwindigkeit
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    };

    // --- Slider 1 (Top) ---
    if (topRow) {
      // Wenn bottomRow existiert, nutzen wir Marquee-Config, sonst Single-Config
      const config = bottomRow ? { ...baseConfig, ...marqueeConfig } : { ...baseConfig, ...singleConfig };

      new Swiper(topRow, config);
    }

    // --- Slider 2 (Bottom - Gegengleich) ---
    if (bottomRow) {
      new Swiper(bottomRow, {
        ...baseConfig,
        ...marqueeConfig,
        autoplay: {
          ...marqueeConfig.autoplay,
          reverseDirection: true, // Gegengleich
        },
      });
    }
  });
});
